import { tokens } from '@fiverr-private/theme';
import { BlockedActionType } from '@fiverr-private/identification_core';

import contactSellerCheckoutImg from '../../../assets/contact_seller_checkout.png';
import postBriefImg from '../../../assets/post_brief.png';
import becomeSellerImg from '../../../assets/become_a_seller.png';
import saveFavoriteImg from '../../../assets/save_favorite.png';

export type BannerActionTypeValue = 'contact_seller' | 'checkout' | 'save_favorite' | 'post_brief' | 'become_a_seller';
export const BANNER_ACTION_TYPE_COPY_KEY_MAP: Record<
    Exclude<BlockedActionType, 'new_brief_and_match'>,
    BannerActionTypeValue
> = {
    contact_seller: 'contact_seller',
    continue_to_checkout: 'checkout',
    save_to_list: 'save_favorite',
    post_a_brief: 'post_brief',
    become_a_seller: 'become_a_seller',
};

export const BANNER_ACTION_COLOR_CLASS_MAP: Record<
    Exclude<BlockedActionType, 'new_brief_and_match'>,
    keyof typeof tokens.colors
> = {
    contact_seller: 'pink_700',
    continue_to_checkout: 'green_700',
    save_to_list: 'lightOrange_700',
    post_a_brief: 'pink_700',
    become_a_seller: 'orange_700',
};

export const BANNER_IMAGE_MAP: Record<Exclude<BlockedActionType, 'new_brief_and_match'>, string> = {
    contact_seller: contactSellerCheckoutImg,
    continue_to_checkout: contactSellerCheckoutImg,
    save_to_list: saveFavoriteImg,
    post_a_brief: postBriefImg,
    become_a_seller: becomeSellerImg,
};
